/* RIVYRE — storefront behaviour. Vanilla, no dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- bind guards ----------------
     boot() runs again on every shopify:section:load. Without a guard the
     document-level delegated listeners, the sticky bar's scroll handler and —
     worst of all — each form's submit handler were re-registered every time,
     so a single tap in the theme editor could fire two /cart/add requests and
     add the item twice. Global listeners bind once for the page; per-element
     work is marked on the element itself, so a genuinely re-rendered section
     still gets wired up while untouched ones are left alone. */

  var globalsBound = false;

  function bindOnce(el, key) {
    if (!el) return false;
    var flag = 'spBound' + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = '1';
    return true;
  }

  /* ---------------- product data ---------------- */

  function readProductData() {
    var el = document.getElementById('sp-product-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var DATA = readProductData();
  var current = null;

  function variantById(id) {
    if (!DATA) return null;
    for (var i = 0; i < DATA.variants.length; i++) {
      if (String(DATA.variants[i].id) === String(id)) return DATA.variants[i];
    }
    return null;
  }

  function variantByOption(value) {
    if (!DATA) return null;
    for (var i = 0; i < DATA.variants.length; i++) {
      if (DATA.variants[i].option === value) return DATA.variants[i];
    }
    return null;
  }

  /* ---------------- money ----------------
     Formats cents through the shop's own money format so a multi-unit total
     never invents a currency layout. Falls back to the raw variant string if
     the format is missing for any reason. */

  function formatMoney(cents) {
    var fmt = DATA && DATA.moneyFormat;
    if (!fmt) return null;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      var withComma = function (n) { return n.replace(/(\d)(?=(\d{3})+$)/g, '$1,'); };
      var units = Math.floor(Math.abs(cents) / 100);
      var frac = Math.abs(cents) % 100;
      var two = (frac < 10 ? '0' : '') + frac;
      switch (token) {
        case 'amount': return withComma(String(units)) + '.' + two;
        case 'amount_no_decimals': return withComma(String(Math.round(Math.abs(cents) / 100)));
        case 'amount_with_comma_separator': return String(units).replace(/(\d)(?=(\d{3})+$)/g, '$1.') + ',' + two;
        case 'amount_no_decimals_with_comma_separator': return String(Math.round(Math.abs(cents) / 100)).replace(/(\d)(?=(\d{3})+$)/g, '$1.');
        default: return withComma(String(units)) + '.' + two;
      }
    });
  }

  /* ---------------- offer selector ----------------
     Single / Duo (/ optional Trio). Holds only the customer's choice; the real
     price is whatever Shopify charges when the line items reach the cart. */

  var offerState = { tier: 'single', units: 1, unitColours: {} };

  /* There can now be more than one offer selector on a page — the hero has one
     and the closing buy band has another. They are mirrors of a single decision,
     not independent widgets: choosing Duo anywhere means the customer wants two
     bracelets, and every block has to say so. The state therefore stays global
     and every query below runs across all instances. */
  function offersRoots() { return document.querySelectorAll('[data-sp-offers]'); }
  function offersRoot() { return document.querySelector('[data-sp-offers]'); }

  function offerUnitVariant(unitIndex) {
    // Unit 1 always follows the main swatch row; units 2+ have their own.
    if (unitIndex === 1) return current;
    var chosen = offerState.unitColours[unitIndex];
    return chosen ? variantByOption(chosen) : current;
  }

  function offerLineItems() {
    var counts = {};
    for (var u = 1; u <= offerState.units; u++) {
      var v = offerUnitVariant(u);
      if (!v) return null;
      counts[v.id] = (counts[v.id] || 0) + 1;
    }
    // Identical colours collapse into one line of quantity N; mixed colours
    // become separate lines. Either way it is a single add request.
    return Object.keys(counts).map(function (id) {
      return { id: Number(id), quantity: counts[id] };
    });
  }

  /* A tier carrying data-bundle-cents is priced by a real Shopify discount, not
     by adding its units up. The attribute is only present when the merchant has
     entered a bundle price, and it is their job to keep it equal to what
     checkout takes — the theme still never applies a discount of its own, it
     only reports one that already exists. Absent the attribute this is the
     original honest per-unit sum. */
  function bundleCentsFor(tier) {
    var root = offersRoot();
    var btn = root && root.querySelector('[data-sp-offer="' + tier + '"]');
    if (!btn) return 0;
    return Number(btn.getAttribute('data-bundle-cents')) || 0;
  }

  function offerTotalCents() {
    var bundle = bundleCentsFor(offerState.tier);
    if (bundle > 0) return bundle;
    var total = 0;
    for (var u = 1; u <= offerState.units; u++) {
      var v = offerUnitVariant(u);
      if (!v) return null;
      total += v.priceCents || 0;
    }
    return total;
  }

  function renderOfferPrices() {
    if (!DATA) return;
    var base = current || DATA.variants[0];
    if (!base) return;
    document.querySelectorAll('[data-sp-offer-price]').forEach(function (el) {
      var btn = el.closest('[data-sp-offer]');
      var units = btn ? Number(btn.getAttribute('data-units')) || 1 : 1;
      var bundle = btn ? Number(btn.getAttribute('data-bundle-cents')) || 0 : 0;
      var cents;
      if (bundle > 0) {
        // Priced by a real discount: the same figure whether or not it is the
        // selected tier, so the card never changes price just by being chosen.
        cents = bundle;
      } else {
        cents = (base.priceCents || 0) * units;
        // Unit-accurate for the selected tier, which may mix colours/prices.
        if (btn && btn.getAttribute('data-sp-offer') === offerState.tier) {
          var exact = offerTotalCents();
          if (exact !== null) cents = exact;
        }
      }
      el.textContent = formatMoney(cents) || base.price;
    });

    // The struck-through figure tracks the live unit price, so changing the
    // product price in Admin cannot leave a stale "was" on the page.
    document.querySelectorAll('[data-sp-offer-compare]').forEach(function (el) {
      var btn = el.closest('[data-sp-offer]');
      var units = btn ? Number(btn.getAttribute('data-units')) || 1 : 1;
      var full = (base.priceCents || 0) * units;
      var bundle = btn ? Number(btn.getAttribute('data-bundle-cents')) || 0 : 0;
      if (bundle > 0 && bundle < full) {
        el.textContent = formatMoney(full) || '';
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    renderHeadlinePrice(base);
  }

  /* The headline price sits above the offer cards, so while Duo was selected
     the block read "$29.99" in 30px type with "Duo — $59.98" selected directly
     beneath it and an Add to cart that charged $59.98. Same real Shopify price
     either way, but the customer was shown the wrong number for what the button
     was about to do. The headline now follows the selected tier, with an
     explicit unit count so the figure is never ambiguous.

     Only the price inside the block that actually owns the offer selector is
     touched. The sticky bar and the final CTA add a single unit and keep the
     single-unit price, which is what they genuinely charge. */
  function renderHeadlinePrice(base) {
    // Every buy block that owns an offer selector shows the selected tier's
    // total. Blocks without one (the sticky bar) keep the single-unit price,
    // which is what they genuinely charge.
    offersRoots().forEach(function (root) {
      var owner = root.closest('[data-sp-buy]');
      if (!owner) return;
      var priceEl = owner.querySelector('[data-sp-price]');
      if (!priceEl) return;
      var qtyEl = owner.querySelector('[data-sp-price-qty]');
      if (offerState.units > 1) {
        var total = offerTotalCents();
        if (total !== null) priceEl.textContent = formatMoney(total) || base.price;
        if (qtyEl) { qtyEl.textContent = 'for ' + offerState.units; qtyEl.hidden = false; }
      } else {
        priceEl.textContent = base.price;
        if (qtyEl) { qtyEl.textContent = ''; qtyEl.hidden = true; }
      }
    });

    // Blocks that follow the selection without owning a selector.
    document.querySelectorAll('[data-sp-offer-follow]').forEach(function (bar) {
      var priceEl = bar.querySelector('[data-sp-price]');
      if (!priceEl) return;
      var qtyEl = bar.querySelector('[data-sp-price-qty]');
      if (offerState.units > 1) {
        var t = offerTotalCents();
        if (t !== null) priceEl.textContent = formatMoney(t) || base.price;
        if (qtyEl) { qtyEl.textContent = ' for ' + offerState.units; qtyEl.hidden = false; }
      } else {
        priceEl.textContent = base.price;
        if (qtyEl) { qtyEl.textContent = ''; qtyEl.hidden = true; }
      }
    });
  }

  function syncUnitVisibility() {
    var anyVisible = offerState.units > 1;
    document.querySelectorAll('[data-sp-units]').forEach(function (wrap) {
      wrap.hidden = !anyVisible;
      wrap.querySelectorAll('[data-sp-unit]').forEach(function (unit) {
        unit.hidden = Number(unit.getAttribute('data-sp-unit')) > offerState.units;
      });
    });
  }

  function selectOffer(tier) {
    var probe = document.querySelector('[data-sp-offer="' + tier + '"]');
    if (!probe) return;
    offerState.tier = tier;
    offerState.units = Number(probe.getAttribute('data-units')) || 1;
    // Mirror the choice into every offer block on the page.
    document.querySelectorAll('[data-sp-offer]').forEach(function (b) {
      var on = b.getAttribute('data-sp-offer') === tier;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.classList.toggle('is-selected', on);
      // Roving tabindex: a radiogroup is one tab stop, and the arrow keys move
      // within it. Leaving every radio focusable made a keyboard user tab
      // through each tier separately before reaching Add to cart.
      b.tabIndex = on ? 0 : -1;
    });
    syncUnitVisibility();
    renderOfferPrices();
  }

  function selectUnitColour(unitIndex, value) {
    offerState.unitColours[unitIndex] = value;
    document.querySelectorAll('[data-sp-unit="' + unitIndex + '"]').forEach(function (unit) {
      unit.querySelectorAll('[data-sp-unit-swatch]').forEach(function (b) {
        var on = b.getAttribute('data-sp-unit-swatch') === value;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.classList.toggle('is-selected', on);
        b.tabIndex = on ? 0 : -1;
      });
    });
    renderOfferPrices();
  }

  function initOffers() {
    var roots = offersRoots();
    if (!roots.length) return;
    var firstRoot = roots[0];
    roots.forEach(function (root) {
    if (!bindOnce(root, 'Offers')) return;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sp-offer]');
      if (btn) selectOffer(btn.getAttribute('data-sp-offer'));
    });

    // Roving selection with arrow keys, matching the swatch radiogroup.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var all = Array.prototype.slice.call(root.querySelectorAll('[data-sp-offer]'));
      var i = all.indexOf(document.activeElement.closest('[data-sp-offer]'));
      if (i < 0) return;
      e.preventDefault();
      var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? (i + 1) % all.length : (i - 1 + all.length) % all.length;
      all[next].focus();
      selectOffer(all[next].getAttribute('data-sp-offer'));
    });

    });

    document.querySelectorAll('[data-sp-units]').forEach(function (units) {
      if (!bindOnce(units, 'Units')) return;
      units.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sp-unit-swatch]');
        if (!b || b.disabled) return;
        var unitEl = b.closest('[data-sp-unit]');
        selectUnitColour(Number(unitEl.getAttribute('data-sp-unit')), b.getAttribute('data-sp-unit-swatch'));
      });
      // Arrow keys inside each per-bracelet colour group. Required now that the
      // group uses a roving tabindex: without it the unselected colour has
      // tabindex -1 and would be unreachable from the keyboard entirely.
      units.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        var unitEl = e.target.closest('[data-sp-unit]');
        if (!unitEl) return;
        var items = Array.prototype.slice.call(unitEl.querySelectorAll('[data-sp-unit-swatch]:not([disabled])'));
        var i = items.indexOf(e.target.closest('[data-sp-unit-swatch]'));
        if (i < 0) return;
        e.preventDefault();
        var fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
        var next = fwd ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
        selectUnitColour(Number(unitEl.getAttribute('data-sp-unit')), items[next].getAttribute('data-sp-unit-swatch'));
        items[next].focus();
      });

      // Default every extra unit to the first available colour so Duo is always
      // addable without forcing a second decision on the customer. Already-made
      // choices are never overwritten when a second block initialises.
      units.querySelectorAll('[data-sp-unit]').forEach(function (unit) {
        var idx = Number(unit.getAttribute('data-sp-unit'));
        if (offerState.unitColours[idx]) return;
        var first = unit.querySelector('[data-sp-unit-swatch]:not([disabled])');
        if (first) selectUnitColour(idx, first.getAttribute('data-sp-unit-swatch'));
      });
    });

    selectOffer(offerState.tier || firstRoot.getAttribute('data-default-offer') || 'single');
  }

  /* ---------------- gallery ----------------
     Two modes, one markup. On a desktop the stage shows a single frame and the
     thumbnail strip switches it. On a phone the thumbnail strip is hidden and
     the stage is a scroll-snapped rail, because a customer could otherwise only
     ever see the one photograph matching the selected colour — four of the six
     were unreachable. In rail mode nothing is hidden; selecting a colour scrolls
     to that plate instead, and the dots follow the scroll position. */

  var railQuery = window.matchMedia('(max-width: 749px)');
  function isRail() { return railQuery.matches; }

  function stageOf(gallery) { return gallery.querySelector('.sp-gallery__stage'); }

  function syncDots(gallery, mediaId) {
    var dots = gallery.querySelectorAll('[data-sp-dot]');
    if (!dots.length) return;
    dots.forEach(function (d) {
      d.setAttribute('aria-current', d.getAttribute('data-sp-dot') === String(mediaId) ? 'true' : 'false');
    });
  }

  function frameAt(gallery, index) {
    var frames = gallery.querySelectorAll('[data-sp-media-id]');
    return frames[Math.max(0, Math.min(frames.length - 1, index))] || null;
  }

  function currentRailFrame(gallery) {
    var stage = stageOf(gallery);
    if (!stage || !stage.clientWidth) return null;
    return frameAt(gallery, Math.round(stage.scrollLeft / stage.clientWidth));
  }

  function showMedia(mediaId) {
    document.querySelectorAll('[data-sp-gallery]').forEach(function (gallery) {
      var frames = gallery.querySelectorAll('[data-sp-media-id]');
      if (!frames.length) return;

      if (isRail()) {
        // Every frame stays in flow; the rail scrolls to the requested one.
        frames.forEach(function (f) { f.hidden = false; });
        var target = null;
        frames.forEach(function (f) {
          if (f.getAttribute('data-sp-media-id') === String(mediaId)) target = f;
        });
        if (!target) target = frames[0];
        var stage = stageOf(gallery);
        if (stage) stage.scrollLeft = target.offsetLeft - stage.offsetLeft;
        syncDots(gallery, target.getAttribute('data-sp-media-id'));
      } else {
        var matched = false;
        frames.forEach(function (f) {
          var hit = f.getAttribute('data-sp-media-id') === String(mediaId);
          if (hit) matched = true;
          f.hidden = !hit;
        });
        if (!matched) {
          frames.forEach(function (f, i) { f.hidden = i !== 0; });
          mediaId = frames[0].getAttribute('data-sp-media-id');
        }
        syncDots(gallery, mediaId);
      }

      gallery.querySelectorAll('[data-sp-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-sp-thumb') === String(mediaId) ? 'true' : 'false');
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-sp-gallery]').forEach(function (gallery) {
      if (!bindOnce(gallery, 'Gallery')) return;

      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-sp-thumb]');
        if (thumb) { showMedia(thumb.getAttribute('data-sp-thumb')); return; }
        var dot = e.target.closest('[data-sp-dot]');
        if (dot) showMedia(dot.getAttribute('data-sp-dot'));
      });

      var stage = stageOf(gallery);
      if (stage) {
        var raf = null;
        stage.addEventListener('scroll', function () {
          if (!isRail() || raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = null;
            var f = currentRailFrame(gallery);
            if (f) syncDots(gallery, f.getAttribute('data-sp-media-id'));
          });
        }, { passive: true });
      }
    });

    // Switching between the two modes has to re-run the layout: coming back to
    // a desktop width with every frame un-hidden would stack all six.
    var onModeChange = function () {
      var id = (current && current.mediaId) || null;
      if (!id) {
        var first = document.querySelector('[data-sp-media-id]');
        id = first && first.getAttribute('data-sp-media-id');
      }
      if (id) showMedia(id);
    };
    if (!globalsBound) {
      if (railQuery.addEventListener) railQuery.addEventListener('change', onModeChange);
      else if (railQuery.addListener) railQuery.addListener(onModeChange);
    }
  }

  /* ---------------- variant selection ---------------- */

  function applyVariant(variant, opts) {
    if (!variant) return;
    current = variant;
    opts = opts || {};

    document.querySelectorAll('[data-sp-price]').forEach(function (n) { n.textContent = variant.price; });

    // Unit 1 of any multi-unit offer follows the main swatch row, so the offer
    // totals have to re-run whenever the headline variant changes.
    renderOfferPrices();

    document.querySelectorAll('[data-sp-compare]').forEach(function (n) {
      if (variant.compareAt) {
        n.textContent = variant.compareAt;
        n.hidden = false;
      } else {
        n.textContent = '';
        n.hidden = true;
      }
    });

    document.querySelectorAll('[data-sp-variant-input]').forEach(function (n) { n.value = variant.id; });

    document.querySelectorAll('[data-sp-selected-label]').forEach(function (n) { n.textContent = variant.option; });

    document.querySelectorAll('[data-sp-swatch]').forEach(function (b) {
      var on = b.getAttribute('data-sp-swatch') === variant.option;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });

    document.querySelectorAll('[data-sp-submit]').forEach(function (btn) {
      var label = btn.querySelector('[data-sp-submit-label]') || btn;
      if (variant.available) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        label.textContent = btn.getAttribute('data-label-add') || 'Add to cart';
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        label.textContent = btn.getAttribute('data-label-sold') || 'Sold out';
      }
    });

    document.querySelectorAll('[data-sp-payment-button]').forEach(function (wrap) {
      wrap.hidden = !variant.available;
    });

    if (variant.mediaId) showMedia(variant.mediaId);

    clearErrors();

    if (!opts.silent && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function initVariantPickers() {
    if (!DATA) return;
    if (!globalsBound) document.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-sp-swatch]');
      if (!swatch) return;
      e.preventDefault();
      var v = variantByOption(swatch.getAttribute('data-sp-swatch'));
      if (v) applyVariant(v);
    });

    // keyboard support for the radio-style group
    document.querySelectorAll('[data-sp-swatches]').forEach(function (group) {
      if (!bindOnce(group, 'Swatches')) return;
      group.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        var items = Array.prototype.slice.call(group.querySelectorAll('[data-sp-swatch]'));
        var idx = items.indexOf(document.activeElement);
        if (idx === -1) return;
        e.preventDefault();
        var next = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? idx + 1 : idx - 1;
        if (next < 0) next = items.length - 1;
        if (next >= items.length) next = 0;
        items[next].focus();
        var v = variantByOption(items[next].getAttribute('data-sp-swatch'));
        if (v) applyVariant(v);
      });
    });

    var params = new URLSearchParams(window.location.search);
    var requested = params.get('variant');
    var initial = (requested && variantById(requested)) || null;
    if (!initial) {
      for (var i = 0; i < DATA.variants.length; i++) {
        if (DATA.variants[i].available) { initial = DATA.variants[i]; break; }
      }
    }
    if (!initial) initial = DATA.variants[0];
    applyVariant(initial, { silent: true });
  }

  /* ---------------- quantity ---------------- */

  function initQuantity() {
    if (globalsBound) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sp-qty]');
      if (!btn) return;
      var wrap = btn.closest('[data-sp-qty-wrap]');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      var step = btn.getAttribute('data-sp-qty') === 'up' ? 1 : -1;
      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = 1;
      input.value = Math.max(1, value + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------- add to cart ---------------- */

  function clearErrors() {
    document.querySelectorAll('[data-sp-error]').forEach(function (n) { n.textContent = ''; });
  }

  function getCartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function initForms() {
    document.querySelectorAll('[data-sp-form]').forEach(function (form) {
      if (!bindOnce(form, 'Form')) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-sp-submit]');
        var errorEl = form.querySelector('[data-sp-error]');
        if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;

        clearErrors();
        if (btn) {
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
        }

        var cart = getCartComponent();
        var sectionIds = (cart && typeof cart.getSectionsToRender === 'function')
          ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
          : null;

        // A form carrying the offer selector posts JSON so a mixed-colour Duo
        // can add two different variants in ONE request. Everything else keeps
        // the plain FormData path.
        // A form whose OWN buy block carries an offer selector posts JSON, so a
        // mixed-colour Duo adds two different variants in one request. A block
        // without one (the sticky bar) keeps the plain FormData path and adds a
        // single unit, which is exactly what its price says it will.
        var ownBlock = form.closest('[data-sp-buy]');
        var follows = !!form.closest('[data-sp-offer-follow]');
        var hasOffers = !!((ownBlock && ownBlock.querySelector('[data-sp-offers]'))
          || (follows && document.querySelector('[data-sp-offers]')));
        var items = hasOffers ? offerLineItems() : null;
        var usesOffers = !!(items && items.length && hasOffers);

        var request;
        if (usesOffers) {
          var payload = { items: items };
          if (sectionIds) { payload.sections = sectionIds; payload.sections_url = window.location.pathname; }
          request = fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload)
          });
        } else {
          var body = new FormData(form);
          if (sectionIds) {
            body.append('sections', sectionIds);
            body.append('sections_url', window.location.pathname);
          }
          request = fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: body
          });
        }

        request
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              if (errorEl) errorEl.textContent = data.description || data.message || 'This item could not be added to your cart.';
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
              // Dawn puts .is-empty on the <cart-drawer> host element, but
              // renderContents only clears it from .drawer__inner, and the
              // section re-render swaps #CartDrawer's inner HTML without
              // touching the host's classes. So on any page first loaded with
              // an empty cart, the drawer opened after an add with its line
              // items still hidden by `.is-empty .cart__contents{display:none}`
              // — a total and a checkout button over an empty panel. The add
              // succeeded, so the cart is by definition no longer empty.
              cart.classList.remove('is-empty');
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(function () {
            if (errorEl) errorEl.textContent = 'Something went wrong. Please check your connection and try again.';
          })
          .finally(function () {
            if (btn) {
              btn.classList.remove('is-loading');
              btn.removeAttribute('aria-busy');
              btn.disabled = !(current && current.available);
            }
          });
      });
    });
  }

  /* ---------------- sticky purchase bar ---------------- */

  function initSticky() {
    var bar = document.querySelector('[data-sp-sticky]');
    if (!bar) return;

    var heroAnchor = document.querySelector('[data-sp-hero-anchor]');
    // Every section that already offers the customer a way to buy. The bar
    // stands down while ANY of them is on screen, so there is never a second
    // Add to cart competing with a real one the customer can already see.
    var ctaAnchors = Array.prototype.slice.call(document.querySelectorAll('[data-sp-band-anchor]'));
    if (!heroAnchor) { bar.remove(); return; }
    if (!bindOnce(bar, 'Sticky')) return;

    var shown = null;

    // Trigger off the hero's Add to cart, not the whole hero column. Waiting for
    // the entire hero to clear the viewport left a paid-traffic visitor with no
    // visible buy control for most of a screen's worth of scrolling on a phone.
    var heroCta = heroAnchor.querySelector('[data-sp-submit]') || heroAnchor;

    function measure() {
      // The bar stands in as soon as the hero's own Add to cart is off screen,
      // and steps aside while the second buy band is on screen.
      var heroOut = heroCta.getBoundingClientRect().bottom < 0;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var ctaIn = ctaAnchors.some(function (el) {
        var b = el.getBoundingClientRect();
        return b.top < vh && b.bottom > 0;
      });

      var show = heroOut && !ctaIn;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    // Two rect reads and, at most, one class toggle per event: cheap enough to
    // run straight off the scroll listener, and it never depends on a frame
    // being painted the way requestAnimationFrame does.
    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    measure();
  }

  /* ---------------- reveal ---------------- */

  function initReveal() {
    var items = document.querySelectorAll('.sp-reveal');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    items.forEach(function (el) { if (bindOnce(el, 'Reveal')) io.observe(el); });

    // Safety net: an observer that's slow or never fires (a backgrounded tab,
    // a throttled device, a browser quirk) must never leave content invisible
    // forever. Anything still unrevealed ~1.2s after boot is shown as-is,
    // with no animation — missing content is worse than missing a fade-in.
    window.setTimeout(function () {
      items.forEach(function (el) {
        if (!el.classList.contains('is-in')) el.classList.add('is-in');
      });
      io.disconnect();
    }, 1200);
  }

  /* ---------------- videos ----------------
     Only the clip actually on screen plays. Everything else stays paused with
     preload="none", so a row of three vertical clips never becomes three
     simultaneous downloads on a phone data plan. Under prefers-reduced-motion
     nothing autoplays and the poster stands in until the visitor asks. */

  function initVideos() {
    var vids = document.querySelectorAll('[data-sp-vid]');
    if (!vids.length) return;

    function setToggleState(video) {
      var card = video.closest('.sp-vid');
      var btn = card && card.querySelector('[data-sp-vid-toggle]');
      if (!btn) return;
      var playing = !video.paused && !video.ended;
      card.classList.toggle('is-paused', !playing);
      btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    // Manual pause is sticky: once a visitor pauses a clip, scrolling away and
    // back must not start it again behind their back.
    vids.forEach(function (v) {
      if (!bindOnce(v, 'Vid')) { setToggleState(v); return; }
      v.addEventListener('play', function () { setToggleState(v); });
      v.addEventListener('pause', function () { setToggleState(v); });
      setToggleState(v);
    });

    document.querySelectorAll('[data-sp-vid-toggle]').forEach(function (btn) {
      if (!bindOnce(btn, 'VidToggle')) return;
      btn.addEventListener('click', function () {
        var video = btn.closest('.sp-vid').querySelector('[data-sp-vid]');
        if (!video) return;
        if (video.paused) {
          video.dataset.spUserPaused = '';
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.dataset.spUserPaused = 'true';
          video.pause();
        }
      });
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.dataset.spUserPaused = 'true'; setToggleState(v); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
          if (v.dataset.spUserPaused === 'true') return;
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.55] });

    vids.forEach(function (v) { if (bindOnce(v, 'VidObs')) io.observe(v); });

    // A backgrounded tab should not keep decoding video.
    if (!globalsBound) {
      document.addEventListener('visibilitychange', function () {
        document.querySelectorAll('[data-sp-vid]').forEach(function (v) {
          if (document.hidden && !v.paused) v.pause();
        });
      });
    }
  }

  /* ---------------- in-page navigation ----------------
     The mobile menu was effectively dead. Tapping "How it works" DID scroll the
     document — but the drawer stayed open over it with `overflow-hidden` still
     on the body, so nothing appeared to happen at all, and the next tap on the
     burger closed the panel to reveal a page that had already moved. Four of
     the five menu items are in-page anchors, so four of five did this.

     The cause is Dawn's own API surface. `MenuDrawer.closeMenuDrawer(event,
     elementToFocus)` returns early when `event === undefined`, and
     `HeaderDrawer` overrides it with a second guard that returns early when
     `elementToFocus` is falsy. A same-document anchor never unloads the page,
     so nothing was ever calling it with both arguments. We call it correctly
     here rather than reaching past it and yanking attributes off the element,
     so the focus trap, the body class and the close animation all still run. */

  function anchorTargetOf(a) {
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i < 0) return null;
    var hash = href.slice(i + 1);
    if (!hash) return null;
    var path = href.slice(0, i);
    // Only treat it as in-page when the link really points at this document.
    if (path && path !== '/' && path !== window.location.pathname) return null;
    return { hash: hash, el: document.getElementById(hash) };
  }

  /* A menu entry pointing at an anchor that does not exist on this template is
     worse than no entry: it looks live, does nothing, and reads as a broken
     site. The menu itself is Shopify Admin data and cannot be edited from the
     theme, so the item is hidden here instead. It reappears by itself the
     moment the anchor exists or the merchant repoints the link. */
  function pruneDeadAnchors() {
    document.querySelectorAll('.header__inline-menu a[href*="#"], .menu-drawer a[href*="#"]').forEach(function (a) {
      var t = anchorTargetOf(a);
      if (!t) return;
      var host = a.closest('li') || a;
      var dead = !t.el;
      host.hidden = dead;
      if (dead) a.setAttribute('tabindex', '-1'); else a.removeAttribute('tabindex');
    });
  }

  function initNav() {
    pruneDeadAnchors();
    if (globalsBound) return;

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var t = anchorTargetOf(a);
      if (!t || !t.el) return;

      var drawer = a.closest('.menu-drawer') ? document.querySelector('header-drawer') : null;
      e.preventDefault();

      if (drawer && typeof drawer.closeMenuDrawer === 'function') {
        var summary = drawer.querySelector('summary');
        // Both arguments are required or Dawn's two guards bail out silently.
        try { drawer.closeMenuDrawer(e, summary); } catch (err) {}

        /* Dawn only resets aria-expanded when the event is a KeyboardEvent:
             if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false)
           We close on a *click*, so the summary kept aria-expanded="true" — and
           base.css paints a full-viewport scrim off exactly that selector:
             .header__icon--menu[aria-expanded='true']::before {
               height: calc(var(--viewport-height) - var(--header-bottom-position));
               background: rgba(var(--color-foreground), 0.5); }
           On the dark scheme --color-foreground is 245,243,238, so the scrim is
           WHITE at 50% — the pale sheet left lying over the whole page after the
           menu closed, swallowing every tap beneath it. Resetting the attribute
           is both the visual fix and the correct accessible state. */
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      // The body's overflow lock is released synchronously inside that call, so
      // the scroll lands even while the panel is still animating away.
      window.setTimeout(function () {
        t.el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + t.hash);
        }
      }, drawer ? 180 : 0);
    });
  }

  /* ---------------- boot ---------------- */

  function boot() {
    initGallery();
    initVariantPickers();
    initOffers();
    initQuantity();
    initForms();
    initSticky();
    initReveal();
    initVideos();
    initNav();
    globalsBound = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
